import React, { Fragment } from 'react';
import { Translate } from '../contexts/Language';

export const Modal = (props) => {


    return (
        (props.Show) ?
            <Fragment>
                <div className="modal fade bs-example-modal-lg show d-block fadeIn" tabIndex="-1" role="dialog">
                    <div className={`modal-dialog ${props.smallSize ? 'modal-md' : props.xlSize ? 'modal-xl' : 'modal-lg' } ${props.centered && 'modal-dialog-centered'}`} role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0" id="myLargeModalLabel">{props.Title}</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={props.onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {props.children}
                            </div>
                            <div className="modal-footer">
                                {
                                    props.Withdraw && (props.Status === "Cancel" || props.Status === "Confirm") ?
                                        <button type="button" className="btn btn-warning waves-effect" onClick={props.onPending} data-dismiss="modal">{Translate("Set Pending")}</button>
                                        : ""
                                }
                                {
                                    props.Deposit && (props.Status === 'Temp' || props.Status === 'Manual') &&
                                        <button type="button" className="btn btn-warning waves-effect" onClick={props.onSetStatus} data-dismiss="modal">{Translate("Set Status to Confirm")}</button>
                                }
                                <button type="button" className="btn btn-secondary waves-effect" onClick={props.onClose} data-dismiss="modal">{Translate("Close")}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </Fragment>
            : ""
    )
}